<template>
  <div class="app-main-content financial-report">
    <div class="details-view">
      <div class="main-content">
        <span style="position: absolute; right: 10px; margin-top: 5px;z-index: 9999">
          <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
        </span>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%;" @tab-click="handleTabClick">
            <el-tab-pane label="Balance sheet-Month" name="balanceSheetMonth">
              <balance-sheet-month ref="balanceSheetMonth" key="balanceSheetMonth" :account-set="accountSet" :statement-description="currentStatementDescription" />
            </el-tab-pane>
            <el-tab-pane label="Balance sheet-Year" name="balanceSheetYear">
              <balance-sheet-year ref="balanceSheetYear" key="balanceSheetYear" :account-set="accountSet" :statement-description="currentStatementDescription" />
            </el-tab-pane>
            <el-tab-pane label="Profit&Loss-Month" name="profitLossMonth">
              <profit-loss-month ref="profitLossMonth" key="profitLossMonth" :account-set="accountSet" :statement-description="currentStatementDescription" />
            </el-tab-pane>
            <el-tab-pane label="Profit&Loss-Year" name="profitLossYear">
              <profit-loss-year ref="profitLossYear" key="profitLossYear" :account-set="accountSet" :statement-description="currentStatementDescription" />
            </el-tab-pane>
            <el-tab-pane label="Trial Balance" name="trialBalance">
              <trial-balance ref="trialBalance" key="trialBalance" :account-set="accountSet" :statement-description="currentStatementDescription" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- 选择账套 -->
      <account-set-popup
        ref="refAccountSetPopup"
        :mode="accountSetPopup.mode"
        :visible.sync="accountSetPopup.visible"
        :load-accounting-document-type-flag="false"
        :load-mapping-departments-flag="false"
        :load-mapping-staffs-flag="false"
        :load-accounting-documents-rule-flag="false"
        :sort-fiscal-period-desc="true"
        :load-year-quarter="true"
        :load-usa-report-flag="true"
        @cancel="()=>accountSetPopup.visible=false"
        @select="accountSetSelectHandler"
      />
    </div>
  </div>
</template>

<script>
import BalanceSheetMonth from '@/views/cargo/v0/FinanceManage/UsaReport/BalanceSheetMonth'
import BalanceSheetYear from '@/views/cargo/v0/FinanceManage/UsaReport/BalanceSheetYear'
import ProfitLossMonth from '@/views/cargo/v0/FinanceManage/UsaReport/ProfitLossMonth'
import ProfitLossYear from '@/views/cargo/v0/FinanceManage/UsaReport/ProfitLossYear'
import TrialBalance from '@/views/cargo/v0/FinanceManage/UsaReport/TrialBalance'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'UsaReport',
  components: { BalanceSheetMonth, BalanceSheetYear, ProfitLossMonth, ProfitLossYear, TrialBalance, AccountSetPopup },
  data() {
    return {
      activeTabName: 'balanceSheetMonth',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    },
    accountSets() {
      return this.$refs['refAccountSetPopup'] ? this.$refs['refAccountSetPopup'].rowData : []
    },
    statementDescriptions() {
      return this.accountSet ? this.accountSet.statementDescription : []
    },
    // 当前页签
    currentStatementDescription() {
      if (this.statementDescriptions && this.activeTabName) {
        return this.statementDescriptions.find(fp => fp.statementName.toLowerCase() === this.activeTabName.toLowerCase())
      }
      return null
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      console.log('selectAccountSetHandler')
      this.accountSetPopup.visible = true
    },
    accountSetSelectHandler(data) {
      this.accountSet = data
      this.$nextTick(() => {
        if (this.$refs[this.activeTabName]) this.$refs[this.activeTabName].defaultFpUuid()
      })
    },
    handleTabClick() {
      this.$refs[this.activeTabName].defaultFpUuid()
    }
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style scoped>

</style>
